import { Allergns } from '@components/Allergns/Allergns';
import { Product as IProduct } from '@interfaces/index';
import { Grow } from '@material-ui/core';
import styled from 'styled-components';

const ProductContainer = styled.article``;

const ProductTitle = styled.h3`
  margin: 0.4rem 0 0.4rem 0;
  font-size: 1rem;
  text-transform: uppercase;
`;

const ProductWrapper = styled.p`
  display: flex;
  justify-content: space-between;
  margin: 0.2rem;
`;

const ProductLine = styled.div`
  background: ${props => props.theme.secondary};
  height: 0.02rem;
  opacity: 1;
  width: 100%;
  margin: 0.4rem 0 0.4rem 0;
`;

const ProductFormats = styled.div`
  display: grid;
  grid-gap: 0.25rem;
  grid-auto-flow: column;
`;

const ProductFormatWraper = styled.div`
  background: ${props => props.theme.secondary};
  color: black;
  text-align: center;
  padding: 0.2rem;
  min-width: 2.3rem;
  border-radius: 0.2rem;
`;

const ProductPrice = styled.span`
  font-size: 0.8rem;
  font-weight: bold;
`;

const ProductBadge = styled.small``;

const ProductFormat = styled.div`
  margin-top: -0.2rem;
  font-size: 0.6rem;
`;

interface ProductProps {
  product: IProduct;
  hasLine: boolean;
}

export const Product = ({ product, hasLine }: ProductProps) => {
  return (
    <Grow in timeout={500}>
      <ProductContainer>
        <ProductTitle>{product.name}</ProductTitle>
        <ProductWrapper>
          <Allergns product={product} size={30} />
          <ProductFormats>
            {product.formats.map((format) => (
              <ProductFormatWraper>
                <ProductPrice>
                  {format.price}
                  <ProductBadge>€</ProductBadge>
                </ProductPrice>
                <ProductFormat>{format.name}</ProductFormat>
              </ProductFormatWraper>
            ))}
          </ProductFormats>
        </ProductWrapper>
        {hasLine && <ProductLine />}
      </ProductContainer>
    </Grow>
  );
};
